import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { FlagValidator } from '../enumeraciones/flag-validator.enum';
import { EnviromentGlobalService } from './enviroment-global.service';
@Injectable()
export class TerminosCondicionesService {

	private API_URL;
	constructor(private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	getTextoPlano(entry: any): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/TerminosCondiciones/Consolidado?id=1&QueryType=${FlagValidator.Todos}`).pipe(
			retry(2)
		);
	}
	aceptarTerminos(entry: any): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/TrazabilidadTerminosCondiciones/AceptarTerminos`, { usuario: entry.usuario }).pipe(
			retry(2));
	}
	validarTerminos(entry: any): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/TrazabilidadTerminosCondiciones/ValidarTerminos`, { usuario: entry.usuario }).pipe(
			retry(2));
	}
}
